import {lazy} from 'react';

export const FxRatesTableLazy = lazy(() => import(/* webpackChunkName: "fxRatesTable" */ '.'));
